import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  setDaySelected,
  setSelectedEvent,
  setShowEventModal,
} from "../../store/schedule/scheduleSlice";

const Day = ({ day, rowIndex }) => {
  const [dayEvents, setDayEvents] = useState([]);
  const dispatch = useDispatch();

  const { savedEvent } = useSelector((state) => state.schedule);

  useEffect(() => {
    const events = savedEvent.filter(
      (evt) => dayjs(evt.day).format("DD-MM-YY") === day.format("DD-MM-YY")
    );

    setDayEvents(events);
  }, [savedEvent, day]);

  const getCurrentDayClass = () => {
    return day.format("DD-MM-YY") === dayjs().format("DD-MM-YY")
      ? "bg-blue-600 text-white rounded-full w-7"
      : "";
  };
  return (
    <div className="border border-gray-200 flex flex-col">
      <header className="flex flex-col items-center">
        {rowIndex === 0 && (
          <p className="text-sm mt-1">{day.format("ddd").toUpperCase()}</p>
        )}
        <p className={`text-sm p-1 my-1 text-center ${getCurrentDayClass()}`}>
          {day.format("DD")}
        </p>
      </header>
      <div
        className="flex-1 cursor-pointer"
        onClick={() => {
          dispatch(setDaySelected(day));
          dispatch(setShowEventModal(true));
        }}
      >
        {dayEvents.map((evt, idx) => {
          return (
            <div
              key={idx}
              onClick={() => dispatch(setSelectedEvent(evt))}
              className={`bg-${evt.label}-200 p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate`}
            >
              {evt.title}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Day;
